import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    State,
    portalTeamsAdapter,
    PORTALTEAMS_FEATURE_KEY,
} from './portal-teams.reducer';

// Lookup the 'PortalTeams' feature state managed by NgRx
export const getPortalTeamsState = createFeatureSelector<State>(
    PORTALTEAMS_FEATURE_KEY
);

const { selectEntities, selectAll } = portalTeamsAdapter.getSelectors();

export const getPortalTeamsLoaded = createSelector(
    getPortalTeamsState,
    (state: State) => state.loaded
);

export const getPortalTeamsLoading = createSelector(
    getPortalTeamsState,
    (state: State) => state.loading
);

export const getPortalTeamsPagination = createSelector(
    getPortalTeamsState,
    (state: State) => state.pagination
);

export const getPortalTeamsError = createSelector(
    getPortalTeamsState,
    (state: State) => state.error
);

export const getAllPortalTeams = createSelector(getPortalTeamsState, selectAll);

export const getPortalTeamsEntities = createSelector(
    getPortalTeamsState,
    selectEntities
);

export const getSelectedId = createSelector(
    getPortalTeamsState,
    (state: State) => state.selectedId
);

export const getSelected = createSelector(
    getPortalTeamsEntities,
    getSelectedId,
    (entities, selectedId) => (selectedId ? entities[selectedId] : undefined)
);

export const selectTeamById = (id: string | number) =>
    createSelector(getPortalTeamsEntities, entities => entities[id]);
